import { Button, MenuItem, styled } from "@mui/material"
import { darken, lighten } from 'polished'


export const ButtonCustom = styled(Button)(({theme}) => ({
  [theme.breakpoints.down("sm")]: {
    minWidth: 32,
    paddingLeft: 8,
    paddingRight: 8,
    "& .MuiButton-startIcon": {
      margin: 0
    }
  }
}))

export const ButtonBlueStyle = styled((props) => {
  // console.log(props)
  return <Button {...props} />
})(({theme}) => ({
    color:"white",
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: lighten(0.1, theme.palette.primary.main),
    },
}));

export const MenuItemCustom = styled((props) => {
  // console.log(props)
  return <MenuItem {...props}/>
})(({theme}) => ({
  color:"white",
  backgroundColor: theme.palette.primary.main,
  '&.Mui-selected': {
    backgroundColor: lighten(0.1,theme.palette.primary.main),
  },
  '&:hover': {
    backgroundColor: `${lighten(0.2, theme.palette.primary.main)} !important`,
  },
}));
